import React from "react";
import "./Image.css";

const Image = () => {
  return (
    <div className="image-container">
      <div className="hero-container">
        <span className="line1"></span>
        <h2 className="hero">AushadhAI</h2>
        <span className="line2"></span>
      </div>
    </div>
  );
};

export default Image;
